import { render } from "./GeneralCampaignSettings.vue?vue&type=template&id=0b3cc7a2"
import script from "./GeneralCampaignSettings.vue?vue&type=script&lang=js"
export * from "./GeneralCampaignSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__